import { Theme } from '@mui/material';

export default function InputBase(theme: Theme) {
  return {
    MuiInputBase: {},
  };
}
